import React from "react";
import { ErrorMessage, Select as BronsonSelect } from "@vwfs-bronson/bronson-react";
import { GenericFieldHTMLAttributes, useField } from "formik";
import { Label } from "./Label";
import { FormField } from "@common/types";

interface Props {
  formField: FormField;
  label: string;
  options: { [value: string]: string } | { value: string; text: string }[];
  infoIconText?: React.ReactNode;
  optional?: boolean;
  showErrorsImmediately?: boolean;
  required?: boolean;
}

export const Select: React.FC<Props & Omit<GenericFieldHTMLAttributes, "name">> = ({ formField, label, options, infoIconText, optional, showErrorsImmediately, required = false, ...props }) => {
  const { fieldName } = formField;
  const [fieldProps, { touched, error }] = useField<string>(fieldName);

  const errorMessage = (touched || showErrorsImmediately) && error ? <ErrorMessage id={fieldName}>{error}</ErrorMessage> : null;

  const itemOptions = Array.isArray(options) ? options : Object.keys(options).map((value) => ({ value, text: options[value] }));

  return (
    <>
      <Label htmlFor={fieldName} text={label} infoIconText={infoIconText} />
      <BronsonSelect {...fieldProps} id={fieldName} error={!!errorMessage} required={required} aria-describedby={`error-${fieldName}`}>
        {fieldProps.value === "" && !optional && <BronsonSelect.Item value="">{"Bitte wählen ..."}</BronsonSelect.Item>}
        {itemOptions.map((option, index) => (
          <BronsonSelect.Item key={index} value={option.value} disabled={option.value === "-"}>
            {option.value === "-" ? "------------------------------" : option.text}
          </BronsonSelect.Item>
        ))}
      </BronsonSelect>
      {errorMessage}
    </>
  );
};
